module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', {
    attrs: {
      "label": "提醒信息"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.iframe.msg_field_id),
      expression: "form.iframe.msg_field_id"
    }],
    domProps: {
      "value": (_vm.form.iframe.msg_field_id)
    },
    on: {
      "input": function($event) {
        _vm.form.iframe.msg_field_id = $event
      }
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + '(' + item.title + ')',
        "value": item.field_id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "URL链接"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.iframe.url_field_id),
      expression: "form.iframe.url_field_id"
    }],
    domProps: {
      "value": (_vm.form.iframe.url_field_id)
    },
    on: {
      "input": function($event) {
        _vm.form.iframe.url_field_id = $event
      }
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + '(' + item.title + ')',
        "value": item.field_id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否允许新建窗口打开"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.iframe.iframeCanOpen),
      expression: "form.iframe.iframeCanOpen"
    }],
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    domProps: {
      "value": (_vm.form.iframe.iframeCanOpen)
    },
    on: {
      "input": function($event) {
        _vm.form.iframe.iframeCanOpen = $event
      }
    }
  }, [_vm._v("允许")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.iframe.iframeCanOpen),
      expression: "form.iframe.iframeCanOpen"
    }],
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    domProps: {
      "value": (_vm.form.iframe.iframeCanOpen)
    },
    on: {
      "input": function($event) {
        _vm.form.iframe.iframeCanOpen = $event
      }
    }
  }, [_vm._v("不允许")])])])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c7d77da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/iframeConfig.vue
// module id = 1939
// module chunks = 2